<template>
  <component
    :is="to ? RouterLink : 'a'"
    :href="to ? null : link"
    :to="to"
    :target="to ? null : '_blank'"
    class="cursor-pointer"
    :title="title"
  >
    <span v-if="label">{{ label }}</span>
    <slot />
  </component>
</template>

<script lang="ts">
import { RouterLink } from "vue-router";

export default {
  name: "DynamicLink",
  setup() {
    return {
      RouterLink,
    };
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    to() {
      if (this.link.includes(window.location.origin))
        return this.link.replace(window.location.origin, "");

      return null;
    },
  },
};
</script>
